import { render } from "./social-modal.vue?vue&type=template&id=0cacdf34"
import script from "./social-modal.vue?vue&type=script&lang=js"
export * from "./social-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__